import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    if (data.mfa_required) return data; // ROOT OWNER — session not established until MFA verified
    setToken(data.token);
    setUser(data);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});
    return data;
  };
  const loginMfa = async (pre_auth, otp, recovery_code) => {
    const { data } = await api.post("/auth/login/mfa", { pre_auth, otp: otp || "", recovery_code: recovery_code || "" });
    setToken(data.token);
    setUser(data);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {});
    return data;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setToken(data.token);
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, loginMfa, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
